export function dataURLtoFile(dataURL, fileName) {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type: mime});
}

export function getVideoPosterImageFileByFile(file) {
  return new Promise(resolve => {
    const blob = new Blob([file], {type: "video/mp4"});
    const reader = new FileReader();
    reader.onload = evt => {
      let video = document.createElement("video");
      video.setAttribute("crossOrigin", "anonymous");
      video.setAttribute("src", evt.target.result);
      video.setAttribute("style", "display:none;")
      video.setAttribute("controls", "controls");
      video.setAttribute("width", 2100);
      video.setAttribute("height", 1050);
      video.setAttribute("preload", "auto");
      video.setAttribute("muted", true);
      video.currentTime = 5;
      video.addEventListener("loadeddata", () => {
        let canvas = document.createElement("canvas"), width = video.width, height = video.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(video, 0, 0, width, height);
        const dataURL = canvas.toDataURL("image/png");
        const file = dataURLtoFile(dataURL, `${new Date().getTime()}.png`);
        resolve(file);
      });
    }
    reader.readAsDataURL(blob);
  });
}